<template>
  <div class="modules-tools" v-if="user">
    <div class="modules-tools__block" v-if="ksoddModules.length">
      <div class="modules-tools__block-title">
        <r-title type="subtitle-1">
          {{ $t(`modules-tools:block-title-ksodd`) }}
        </r-title>
      </div>
      <div class="modules-tools__block-content">
        <modules-tools-item
          :module="item"
          v-for="item in ksoddModules"
          :key="item.id"
        />
      </div>
    </div>
    <div class="modules-tools__block" v-if="mtpModules.length">
      <div class="modules-tools__block-title">
        <r-title type="subtitle-1">
          {{ $t(`modules-tools:block-title-mtp`) }}
        </r-title>
      </div>
      <div class="modules-tools__block-content">
        <modules-tools-item
          :module="item"
          v-for="item in mtpModules"
          :key="item.id"
        />
      </div>
    </div>
    <div class="modules-tools__block" v-if="siCentreModule.length">
      <div class="modules-tools__block-title">
        <r-title type="subtitle-1">
          {{ $t(`modules-tools:block-title-si-centre`) }}
        </r-title>
      </div>
      <div class="modules-tools__block-content">
        <modules-tools-item
          :module="item"
          v-for="item in siCentreModule"
          :key="item.id"
        />
      </div>
    </div>
  </div>
</template>

<script>
import modulesToolsItem from "./components/modules-tools-item";
import isEqual from "lodash.isequal";
import { modulesList } from "./configs/";

export default {
  components: { modulesToolsItem },
  data() {
    return {
      isChanged: false,
      modulesList
    };
  },
  watch: {
    userModules: {
      handler: function() {
        this.isChangedInfo();
      },
      deep: true,
      immediate: true
    },
    isChanged: {
      handler: function(value) {
        this.$store.commit("SET_ACTIVE_USER_CHANGES", {
          module: "modules",
          value
        });
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    instance() {
      return this.$store.state.instance;
    },
    user() {
      return this.$store.state.userRoles.activeUser;
    },
    userModules() {
      return this.$store.state.userRoles.activeUserModules;
    },
    userDS() {
      return this.$store.state.userRoles.activeUserDS;
    },
    initialUserModules() {
      return this.$store.state.userRoles.initialUserModules;
    },
    allModules() {
      return this.$store.state.userRoles.allPerms.modules;
    },
    otherModules() {
      return this.$store.state.userRoles.allPerms.modules.filter(
        (e, i) =>
          e.instruments &&
          e.instruments.length &&
          this.$store.state.userRoles.allPerms.modules.findIndex(
            n => n.id === e.id
          ) === i &&
          e.name !== "Situation Center" &&
          e.name !== "Map" &&
          e.name !== "Book" &&
          e.name !== "Chart" &&
          e.name !== "UserRoles" &&
          e.name !== "DataSourceManager"
      );
    },
    otherSingleModules() {
      return this.$store.state.userRoles.allPerms.modules.filter(
        (e, i) =>
          (!e.instruments || !e.instruments.length) &&
          this.$store.state.userRoles.allPerms.modules.findIndex(
            n => n.id === e.id
          ) === i &&
          e.name !== "Situation Center" &&
          e.name !== "Map" &&
          e.name !== "Book" &&
          e.name !== "Chart" &&
          e.name !== "UserRoles" &&
          e.name !== "DataSourceManager"
      );
    },
    systemModulesList() {
      return this.modulesList[this.instance] || this.modulesList.default;
    },
    ksoddModules() {
      return this.allModules.filter(
        e =>
          this.systemModulesList.gis &&
          this.systemModulesList.gis.indexOf(e.name) > -1
      );
    },
    mtpModules() {
      return this.allModules.filter(
        e =>
          this.systemModulesList.mtp &&
          this.systemModulesList.mtp.indexOf(e.name) > -1
      );
    },
    siCentreModule() {
      return this.$store.state.userRoles.allPerms.modules.filter(
        e => e.name === "Situation Center"
      );
    }
  },
  methods: {
    isChangedInfo() {
      this.isChanged = !isEqual(this.userModules, this.initialUserModules);
    }
  }
};
</script>

<style lang="scss">
.modules-tools {
  &__block {
    margin-bottom: 12px;
    &-title {
      margin-bottom: 12px;
    }
    &-content {
      display: flex;
      flex-wrap: wrap;
      .modules-tools__item {
        margin-right: 16px;
        margin-bottom: 16px;
        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
}
</style>

<i18n>
{
  "ru": {
    "modules-tools:block-title-ksodd": "Цифровой КСОДД",
    "modules-tools:block-title-mtp": "Моделирование транспортных потоков",
    "modules-tools:block-title-si-centre": "Ситуационный центр",
    "modules-tools:block-title-other": "Другие модули и компоненты",

    "user-info:button:save": "Сохранить изменения",
    "user-info:button:cancel": "Отмена",

    "user-info:save-notify:title": "Необходимо заполнить все поля",
    "user-info:save-notify:text": "Заполните ФИО, данные об электронной почте и Вашей компании",

    "user-info:edit-notify:title": "Редактирование пользователя",
    "user-info:edit-notify:text": "Редактирование пользователя выполнено успешно",
    "user-info:edit-notify:error-title": "Ошибка",
    "user-info:edit-notify:error-text": "Редактирование пользователя не выполнено",

    "user-info:create-notify:title": "Создание пользователя",
    "user-info:create-notify:text": "Создание пользователя выполнено успешно",
    "user-info:create-notify:error-title": "Ошибка",
    "user-info:create-notify:error-text": "Создание пользователя не выполнено",

    "before:title": "Предупреждение",
    "before-save:text": "Все изменения для текущего пользователя будут сохранены. Вы уверены?",
    "before-cancel:text": "Все изменения для текущего пользователя будут отменены. Вы уверены?",
    "button-confirm": "Да",
    "button-cancel": "Отмена"
  },
  "en": {
    "modules-tools:block-title-ksodd": "Digital CSODD",
    "modules-tools:block-title-mtp": "Traffic modeling",
    "modules-tools:block-title-si-centre": "Situation center",
    "modules-tools:block-title-other": "Other modules and components",

    "user-info:button:save": "Save changes",
    "user-info:button:cancel": "Cancel",

    "user-info:save-notify:title": "All fields are required.",
    "user-info:save-notify:text": "Fill in the full name, data about e-mail and your company",

    "user-info:edit-notify:title": "User editing",
    "user-info:edit-notify:text": "User editing completed successfully",
    "user-info:edit-notify:error-title": "Error",
    "user-info:edit-notify:error-text": "User editing failed",

    "user-info:create-notify:title": "User creating",
    "user-info:create-notify:text": "User creating completed successfully",
    "user-info:create-notify:error-title": "Error",
    "user-info:create-notify:error-text": "User creating failed",

    "before:title": "Warning",
    "before-save:text": "All changes for the current user will be saved. Are you sure?",
    "before-cancel:text": "All changes for the current user will be discarded. Are you sure?",
    "button-confirm": "Yes",
    "button-cancel": "Cancel"
  }
}
</i18n>
